// Types
import type { CSSProperties } from 'react';

// Hooks
import { useZoomContext } from './ZoomStateContext';

// Utils
import {
    DIRECT_SCALE_ATTRIBUTE_VALUE,
    INVERSE_ZOOM_SCALE_ATTRIBUTE,
    getDirectInverseZoomScaleStyle,
    getInverseZoomScaleStyle,
} from './inverseZoomScaleRenderUtils';

export type InverseZoomScaleProps = {
    [INVERSE_ZOOM_SCALE_ATTRIBUTE]: string;
    style: CSSProperties;
};

/** Returns props for an element that consumes the inverse scale in its CSS. */
export const useInverseZoomScaleProps = (style?: CSSProperties): InverseZoomScaleProps => ({
    [INVERSE_ZOOM_SCALE_ATTRIBUTE]: '',
    style: { ...getInverseZoomScaleStyle(useZoomContext()?.getContextZoomScale?.()), ...style },
});

/** Returns props for an element that only needs its own inverse scale. */
export const useDirectInverseZoomScaleProps = (style?: CSSProperties): InverseZoomScaleProps => ({
    [INVERSE_ZOOM_SCALE_ATTRIBUTE]: DIRECT_SCALE_ATTRIBUTE_VALUE,
    style: { ...getDirectInverseZoomScaleStyle(useZoomContext()?.getContextZoomScale?.()), ...style },
});
